import React from 'react';
import { Form, FormGroup } from "reactstrap";
import InputCustom from "../../../../components/InputCustom";
import LoadingButton from "../../../../components/LoadingButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";

const SetPasswordForm = ({ intl, values, isLoading, isSuccess, settingFailed, handleChange, handleSubmit }) => {
  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
        <InputCustom
          required
          id="new-password"
          name="password"
          type="password"
          value={values.password}
          onChange={handleChange}
          placeHolder={intl.formatMessage({ id: 'SetPassword.password' })}
        />
      </FormGroup>

      <FormGroup>
        <InputCustom
          required
          id="new-password-repeat"
          name="passwordRepeat"
          type="password"
          value={values.passwordRepeat}
          onChange={handleChange}
          placeHolder={intl.formatMessage({ id: 'SetPassword.passwordRepeat' })}
        />
      </FormGroup>

      <div className="text-center">
        <LoadingButton
          isLoading={isLoading}
          isSucceed={isSuccess}
          isFailed={settingFailed}
          value="SetPassword.setPassword"
          type="submit"
          className="btn btn-outline-light btn-block btn-login"
        />
      </div>
      <div className="mt-2 text-center">
        <Link to="/login" className="text-white">
          <FontAwesomeIcon icon={faArrowLeft} className="mr-1" />
          <FormattedMessage id="SetPassword.back" />
        </Link>
      </div>
    </Form>
  );
};

export default injectIntl(SetPasswordForm);
